import React, { useState } from 'react'
import { Modal, Input } from 'antd'
import { FormItem } from 'admin/lib/Forms'
import { useFormContext } from 'react-hook-form'
import { Queries } from 'admin/lib/Api'

export const InternalNotesModal: React.FC<{
  open: boolean
  onClose: () => void
}> = ({ open, onClose }) => {
  const form = useFormContext()
  const [firstClick, setFirstClickToggle] = useState(true)
  const user = Queries.useUserSelf()
  return (
    <Modal
      title="Internal Notes"
      open={open}
      maskClosable={false}
      mask={false}
      footer={null}
      onCancel={() => onClose()}
      styles={{
        mask: {
          background: 'transparent',
          pointerEvents: 'none'
        }
      }}
      style={{
        pointerEvents: 'all',
        position: 'absolute',
        top: '6.5%',
        right: '1%'
      }}
      wrapClassName={'commentSectionModalWrap'}
    >
      <FormItem disabled={user.isLoading} label={''} name={'internalNotes'}>
        <Input.TextArea
          onClick={val => {
            if (firstClick) {
              const firstLetterOfSurname = user.data.lastName.substring(0, 1)
              const formattedUser = `${user.data.firstName} ${firstLetterOfSurname}`

              const target = val.target as HTMLTextAreaElement
              const newLineIfNotEmpty = target.value === '' ? '' : '\n'
              const info = `${new Date().toLocaleString()} ${formattedUser}:`
              setFirstClickToggle(false)
              form.setValue(
                'internalNotes',
                `${target.value}${newLineIfNotEmpty}${info} `
              )
            }
          }}
          style={{ height: '200px' }}
        />
      </FormItem>
    </Modal>
  )
}
